import { render } from "./TrattativaItem.vue?vue&type=template&id=cc432066&scoped=true"
import script from "./TrattativaItem.vue?vue&type=script&lang=js"
export * from "./TrattativaItem.vue?vue&type=script&lang=js"

import "./TrattativaItem.vue?vue&type=style&index=0&id=cc432066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc432066"]])

export default __exports__